import { render, staticRenderFns } from "./CalendarIcon.vue?vue&type=template&id=1af746d4"
import script from "./CalendarIcon.vue?vue&type=script&lang=ts"
export * from "./CalendarIcon.vue?vue&type=script&lang=ts"
import style0 from "./CalendarIcon.vue?vue&type=style&index=0&id=1af746d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports